/**
 * @generated SignedSource<<c7ab0edb90445fb85001674ce7cc0d61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NoteFinderPageOverlayNoteBulb_Bulb$data = {
  readonly bulb_id: string;
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly confidence: number;
  readonly has_dot: boolean;
  readonly main_lines: ReadonlyArray<{
    readonly a: number;
    readonly b: number;
  }>;
  readonly " $fragmentType": "NoteFinderPageOverlayNoteBulb_Bulb";
};
export type NoteFinderPageOverlayNoteBulb_Bulb$key = {
  readonly " $data"?: NoteFinderPageOverlayNoteBulb_Bulb$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageOverlayNoteBulb_Bulb">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteFinderPageOverlayNoteBulb_Bulb",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bulb_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "x",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "y",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "width",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "height",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "confidence",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "has_dot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicParseStepDataNoteBulbLineFinderAndPlacerBulbLine",
      "kind": "LinkedField",
      "name": "main_lines",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "a",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "b",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicParseStepDataNoteDataSourceCombineNoteBulb",
  "abstractKey": null
};

(node as any).hash = "93e5d1e1247af328d4897a65bc026f1a";

export default node;
